import { Avatar, Box, Grid, Stack, useTheme } from '@mui/material';
import { AppImages } from 'app/appImages';
import { MprcLink } from 'components';
import { MprcFeedTypography } from 'components/MprcFeedTypography';
import { Formaters } from 'lib/Formaters';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from "react-router";
import { KnowledgePaths } from 'routes/KnowledgeRouter';
import { UserProfileDialog } from 'views/foundation/user/dialogs/UserProfileDialog';
import { useCardContext } from '../../CardBuilder';
import { CardContextLink } from '../../CardContextLink';
import { StickerBox } from '../common/StickerBox';
import { MyListsOptions } from './MenuOptions';

///
export const FeedMyListsTitle = () => {
    const { pub, pub: { availableInTheFuture, viewPeriodStart } } = useCardContext();
    const theme = useTheme();
    const { t } = useTranslation("knowledge");

    var borderStyle: React.CSSProperties | undefined = (pub.interaction.isNewPublication)
        ? { borderLeft: "4px solid", borderLeftColor: theme.palette.warning.main, paddingLeft: theme.spacing(1) }
        : undefined;

    return (
        <div style={borderStyle}>
            <CardContextLink publicationId={pub.publicationId} to={`${pub.listDefinition?.openInPlayback == true ? KnowledgePaths.ListPublicationInPlayback : KnowledgePaths.ListPublicationViewer}/${pub.publicationId}`}>
                <Box sx={{ color: availableInTheFuture ? "muted.light" : undefined }}>
                    <MprcFeedTypography variant="title" component="div" noWrap={true} color={"inherit"}>
                        <span title={pub.title}>{pub.title}</span>
                    </MprcFeedTypography>
                </Box>
            </CardContextLink>
            <Stack direction="row" spacing={1} alignItems="flex-end">
                {availableInTheFuture && <StickerBox name={t("Feed.Card.Common.DisplayOnText", { date: Formaters.dayMonth(viewPeriodStart) })} textColor={theme.palette.common.white} backgroundColor={theme.palette.muted.light} />}
                {pub.listDefinition?.isPublic === true &&
                    <>
                        {pub.listDefinition?.isCollaborator === true && <StickerBox name={t("Feed.MyLists.CollaboratingText")} textColor={theme.palette.common.white} backgroundColor={theme.palette.warning.main} />}
                        {pub.interaction.followingPublication === true && <StickerBox name={t("Feed.MyLists.FollowingText")} textColor={theme.palette.common.white} backgroundColor={theme.palette.success.main} />}
                    </>
                }
                {pub.sticker && <StickerBox name={pub.sticker.name} textColor={pub.sticker.textColor} backgroundColor={pub.sticker.backgroundColor} />}
            </Stack>
        </div>
    );
};

export const FeedMyListsThumbnail = () => {
    const { pub, pub: { listDefinition } } = useCardContext();

    const thumbnailUrl = listDefinition ? listDefinition.thumbnailUrl : AppImages.KnowledgeListThumbnail;

    return (
        <CardContextLink publicationId={pub.publicationId} to={`${pub.listDefinition?.openInPlayback == true ? KnowledgePaths.ListPublicationInPlayback : KnowledgePaths.ListPublicationViewer}/${pub.publicationId}`}>
            <Box sx={{ width: 154, height: 87 }}>
                <img src={thumbnailUrl} width="100%" height="100%" style={{ objectFit: "contain", borderRadius: "6px" }} />
            </Box>
        </CardContextLink>
    );
};

export const FeedMyListsAuthor = () => {
    const { pub: { publicationId, channel, author, listDefinition } } = useCardContext();

    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation("knowledge");

    const [dialog, setDialog] = useState<any>();

    return (
        <>
            {dialog}
            <Grid container justifyContent="center" alignItems="center" spacing={1}>
                <Grid size="grow">

                    {listDefinition?.isPublic === false ? <>
                        <MprcFeedTypography variant="authorPrimary" component="div">
                            <span title={t("Feed.Card.List.PrivateListText")}>{t("Feed.Card.List.PrivateListText")}</span>
                        </MprcFeedTypography>
                        {listDefinition?.lastUpdateItemsDate &&
                            <MprcFeedTypography variant="authorSecondary" component="div">
                                <span>{t("Feed.MyLists.UpdateAtText")} {Formaters.relativeTime(listDefinition?.lastUpdateItemsDate)}</span>
                            </MprcFeedTypography>
                        }
                        <MprcFeedTypography variant="authorSecondary" component="div">
                            <span>{t("Feed.MyLists.ItemsCountText", { count: listDefinition?.itemCount ?? 0 })}</span>
                        </MprcFeedTypography>
                    </> :
                        <>
                            <Grid container justifyContent="center" alignItems="flex-start" spacing={1}>
                                <Grid>
                                    <MprcLink
                                        onClick={() => setDialog(
                                            <UserProfileDialog
                                                userId={author.userId}
                                                onClose={() => setDialog(null)}
                                                onBeforeLinkClick={() => navigate(document.location.search, { replace: true, state: { ...(location.state ?? {}), publicationId: publicationId } })}
                                            />
                                        )}
                                    >
                                        <Avatar
                                            title={author.name}
                                            sx={{ width: 35, height: 35 }}
                                            src={author.thumbnailUrl}
                                        />
                                    </MprcLink>

                                </Grid>
                                <Grid size="grow">
                                    <MprcLink
                                        onClick={() => setDialog(
                                            <UserProfileDialog
                                                userId={author.userId}
                                                onClose={() => setDialog(null)}
                                                onBeforeLinkClick={() => navigate(document.location.search, { replace: true, state: { ...(location.state ?? {}), publicationId: publicationId } })}
                                            />
                                        )}
                                    >
                                        <MprcFeedTypography variant="authorPrimary" component="div">
                                            <span title={author.name}>{author.name}</span>
                                        </MprcFeedTypography>
                                    </MprcLink>
                                    {listDefinition?.lastUpdateItemsDate &&
                                        <MprcFeedTypography variant="authorSecondary" component="div">
                                            <span>
                                                {t("Feed.MyLists.UpdateAtText")}
                                                {Formaters.relativeTime(listDefinition?.lastUpdateItemsDate)}
                                                {" "}
                                                {t("shared:Literal.In")}
                                                {" "}
                                                <CardContextLink
                                                    publicationId={publicationId}
                                                    to={KnowledgePaths.FeedChannel(channel!.id)}
                                                >
                                                    <strong>{channel!.name}</strong>
                                                </CardContextLink>
                                            </span>
                                        </MprcFeedTypography>
                                    }
                                    <MprcFeedTypography variant="authorSecondary" component="div">
                                        <span>{t("Feed.MyLists.ItemsCountText", { count: listDefinition?.itemCount ?? 0 })}</span>
                                    </MprcFeedTypography>
                                </Grid>
                            </Grid>
                        </>
                    }



                </Grid>
            </Grid>
        </>
    );
};

export const FeedMyListsFooter = () => {
    return (
        <Grid container justifyContent="space-between" alignItems="center">
            <Grid>
            </Grid>
            <Grid>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid>
                        <MyListsOptions />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
